export const removeTpLitePathFromSiteUrl = (siteUrl: string, tpLitePath: string) => {
    return tpLitePath !== "" ? siteUrl.replace(`/${tpLitePath}`, "") : siteUrl
}
